// Merkez Yönetimi sayfası ve pencereleri (merkez formu, SMO genel bakış, bölge
// yönetimi). Excel dosyaları ve kayıtlı değerler ('Aktif' / 'İnaktif') Türkçe kalır.
const centers = {
  page: {
    title: 'Merkez Yönetimi',
    subtitle: 'Çalışma merkezleri, SMO atamaları ve bölge sorumluları tek yerde.',
  },
  status: {
    active: 'Aktif',
    inactive: 'İnaktif',
    all: 'Tümü',
  },
  common: {
    cancel: 'İptal',
    close: 'Kapat',
  },
  actions: {
    add: 'Yeni Merkez',
    regions: 'Bölge Yönetimi',
    regionsHint: 'Türkiye haritası üzerinden bölgeleri ve bölge müdürlerini yönetin',
    smo: 'SMO Genel Bakış',
    smoHint: 'SMO atamalarını detaylı görüntüle',
    excel: 'Tabloyu İndir',
    excelHint: 'Tüm merkezleri görünen sütunlarla Excel olarak indir',
  },
  stats: {
    total: 'Toplam Merkez',
    totalShort: 'Toplam',
    active: 'Aktif Merkez',
    activeShort: 'Aktif',
    inactive: 'İnaktif Merkez',
    inactiveShort: 'İnaktif',
    share: 'Tüm merkezlerin %{{percent}}’i',
  },
  toolbar: {
    search: 'Merkez adı, il veya ilçe ile ara…',
    searchShort: 'Merkez ara…',
    status: 'Merkez durumu',
  },
  table: {
    listLabel: 'Merkez listesi',
    empty: 'Filtrelere uygun merkez bulunamadı',
    rangeOf: '/ {{total}} merkez',
    ofTotal: 'toplam {{total}} merkez içinden',
    jump: 'Sayfaya git',
    noRegion: 'Bölge atanmadı',
    noManager: 'Sorumlu atanmadı',
    regionTitle: '{{region}}: {{managers}}',
  },
  columns: {
    name: 'Adı',
    smo: 'SMO',
    smoBackup: 'Yedek SMO',
    regionManager: 'Bölge Sorumlusu',
    address: 'Adres',
    info: 'Bilgi',
    status: 'Durum',
    city: 'İl',
    district: 'İlçe',
    region: 'Bölge',
  },
  panel: {
    label: 'Seçili merkez',
    heading: 'Merkez',
    edit: 'Düzenle',
    delete: 'Sil',
    deactivate: 'İnaktif Yap',
    activate: 'Aktif Yap',
    toggleHint: 'Durum Değiştir',
  },
  delete: {
    title: 'Merkezi Sil',
    message: '{{name}} merkezini silmek istediğinizden emin misiniz?',
    usedTitle: 'Önemli bilgi',
    usedText: 'Bu merkez SMO Lead Raporlarında kullanılmaktadır. Merkezi silseniz bile, SMO Lead Raporlarındaki bu merkezle ilgili veriler korunacaktır.',
    irreversible: 'Bu işlem geri alınamaz.',
    confirm: 'Merkezi Sil',
  },
  form: {
    titleAdd: 'Yeni Merkez Ekle',
    titleEdit: 'Merkez Düzenle',
    subtitleAdd: 'Merkezin konumunu ve sorumlularını girin',
    sections: {
      basic: 'Merkez Bilgileri',
      people: 'Sorumlular',
      notes: 'Adres ve Notlar',
    },
    name: 'Adı',
    city: 'İl',
    district: 'İlçe',
    authority: 'Yetkili',
    authorityHint: 'Aktif harici personel listesinden seçilir.',
    smo: 'SMO',
    smoBackup: 'SMO Yedek (Backup)',
    peopleHint: 'SMO ve yedek SMO aktif çalışanlar arasından seçilir.',
    status: 'Durum',
    address: 'Adres',
    info: 'Bilgi',
    choose: 'Seçiniz',
    notInList: '{{name}} (aktif listede değil)',
    reset: 'Sıfırla',
    add: 'Ekle',
    update: 'Güncelle',
    processing: 'İşleniyor…',
  },
  smo: {
    title: 'SMO Genel Bakış',
    subtitle: 'Hangi çalışanın hangi merkezde SMO olduğunu görüntüleyin',
    stats: {
      smoCount: 'Toplam SMO',
      withSmo: 'SMO’lu Merkez',
      active: 'Aktif Merkez',
      orphan: 'SMO’suz Merkez',
      average: 'Ort. Merkez / SMO',
    },
    search: 'SMO adı, merkez, il veya ilçe ara…',
    expandAll: 'Tümünü Aç',
    collapseAll: 'Tümünü Kapat',
    excel: 'Excel',
    excelHint: 'SMO atamalarını Excel olarak indir',
    empty: 'Sonuç bulunamadı',
    centerCount: '{{count}} merkez',
    activeCount: '{{count}} aktif',
    inactiveCount: '{{count}} inaktif',
    workerCount: '{{count}} çalışan',
    workersHint: 'Projelerde bu merkeze atanmış çalışan sayısı',
    noLocation: 'Konum belirtilmemiş',
    removeHint: 'Bu merkezden SMO atamasını kaldır',
    showEmployees: 'Bu merkezdeki çalışanları göster',
    employeesTitle: 'Bu merkezde çalışanlar ({{count}})',
    orphanTitle: 'SMO Atanmamış Merkezler',
    orphanCount: '{{count}} merkez SMO ataması bekliyor',
    remove: {
      title: 'SMO Atamasını Kaldır',
      lead: '{{center}} merkezinden {{smo}} SMO atamasını kaldırmak istediğinizden emin misiniz?',
      whatTitle: 'Ne olacak?',
      itemSmo: 'Bu merkezin SMO ataması temizlenecek ve SMO Lead Raporları sayfasında bu merkez için SMO görünmeyecek.',
      itemKept: 'Merkez, çalışanlar, vizitler, takvim ve Manuel Veri Girişi kayıtları korunacaktır. Sadece SMO ataması kaldırılır.',
      itemLater: 'Daha sonra bu merkeze yeni bir SMO atayabilirsiniz.',
      confirm: 'SMO Atamasını Kaldır',
      removing: 'Kaldırılıyor…',
    },
  },
  regions: {
    title: 'Bölge Yönetimi',
    subtitle: 'Haritadan illeri bölgelere atayın; bölge ve il sorumlularını belirleyin',
    hintSelected: 'Haritadan illere tıklayarak {{region}} bölgesine ekleyin / çıkarın',
    hintNone: 'Bir bölge seçin, ardından haritadan illere tıklayarak atama yapın',
    assigned: '{{count}} / 81 il atandı',
    regionCount: '{{count}} bölge',
    listTitle: 'Bölgeler',
    add: 'Yeni Bölge',
    loading: 'Yükleniyor…',
    empty: 'Henüz bölge tanımlanmadı. "Yeni Bölge" ile başlayın.',
    color: 'Bölge rengi',
    namePlaceholder: 'Bölge adı',
    delete: 'Bölgeyi sil',
    managerPlaceholder: 'Bölge müdürü seçin',
    noCities: 'İl atanmadı',
    cityHint: 'Bu il için bölge sorumlularını yönet',
    cityManagerCount: '{{count}} il sorumlusu',
    cityManagers: '{{city}} bölge sorumluları',
    managerCount: '{{count}} sorumlu',
    noCityManagers: 'İl özelinde atama yok',
    fallback: 'Bölge geneli sorumlusu kullanılır: {{name}}',
    noneYet: 'Bu il için henüz sorumlu atanmadı',
    removeManager: 'Sorumluyu kaldır',
    noMoreManagers: 'Eklenebilecek sorumlu kalmadı',
    addManager: 'Sorumlu ekle',
    pickCity: 'İl bazlı sorumlu eklemek için yukarıdan bir il seçin.',
    centers: '{{count}} merkez',
    workers: '{{count}} çalışan',
    projects: '{{count}} proje',
    centersHint: 'Bölgedeki merkez sayısı',
    workersHint: 'Bölgedeki merkezlerde çalışan sayısı',
    projectsHint: 'Bölgedeki merkezlerde yürüyen proje sayısı',
    showCenters: 'Merkez detaylarını göster',
    hideCenters: 'Merkez detaylarını gizle',
    centerMeta: '{{workers}} çalışan · {{projects}} proje',
    save: 'Kaydet',
    saving: 'Kaydediliyor…',
    map: {
      label: 'Türkiye bölge haritası',
      manager: 'Bölge Sorumlusu: {{names}}',
      unassigned: 'Bölge atanmamış',
      summary: '{{centers}} merkez · {{workers}} çalışan · {{projects}} proje',
      centerLine: '{{name}} — {{workers}} çalışan, {{projects}} proje',
      more: '+ {{count}} merkez daha',
    },
  },
  toast: {
    loadError: 'Merkezler yüklenirken bir hata oluştu',
    excelDone: 'Excel dosyası başarıyla indirildi',
    excelError: 'Dosya indirilirken bir hata oluştu',
    statusUpdated: 'Merkez durumu {{status}} olarak güncellendi',
    statusError: 'Durum güncellenirken hata oluştu',
    checkError: 'Merkez kontrol edilirken bir hata oluştu',
    deleted: 'Merkez başarıyla silindi. {{count}} çalışan kaydı güncellendi.',
    deleteError: 'Merkez silinirken bir hata oluştu',
    added: 'Yeni merkez başarıyla eklendi',
    addError: 'Merkez eklenirken bir hata oluştu',
    updated: 'Merkez başarıyla güncellendi!',
    pageJumpInvalid: 'Lütfen 1 ile {{max}} arasında bir sayfa numarası girin.',
    employeesError: 'Çalışanlar yüklenirken bir hata oluştu',
    authoritiesError: 'Yetkililer yüklenirken bir hata oluştu',
    formAdded: 'Merkez başarıyla eklendi!',
    formUpdateError: 'Merkez güncellenirken bir hata oluştu!',
    formAddError: 'Merkez eklenirken bir hata oluştu!',
    smoExcelDone: 'Excel dosyası indirildi',
    smoExcelError: 'Excel indirilemedi',
    smoRemoved: 'SMO ataması kaldırıldı.',
    smoRemovedCount: 'SMO ataması kaldırıldı. {{projects}} projede {{count}} kayıt temizlendi.',
    smoRemoveError: 'SMO kaldırılırken bir hata oluştu',
    regionsLoadError: 'Bölgeler yüklenirken bir hata oluştu',
    pickRegionFirst: 'Önce bölge listesinden bir bölge seçin veya yeni bölge ekleyin',
    regionNameRequired: 'Tüm bölgelere bir isim verin',
    regionsSaved: 'Bölgeler başarıyla kaydedildi',
    regionsSaveError: 'Bölgeler kaydedilirken bir hata oluştu',
  },
};

export default centers;
